import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { selfserviceQuestionInterface } from 'src/app/util/interfaces/selfserviceQuestion';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { templateCustomFieldsReworkInterface } from 'src/app/util/interfaces/templateCustomFieldsRework';
import { templateReworkInterface } from 'src/app/util/interfaces/templateRework';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { groupInterface } from 'src/app/util/interfaces/group';
import { classificationInterface } from 'src/app/util/interfaces/classification';
import { scopeInterface } from 'src/app/util/interfaces/scope';
import { categoryInterface } from 'src/app/util/interfaces/category';
import { topicsInterface } from 'src/app/util/interfaces/topics';
import { kbArchiveInterface } from 'src/app/util/interfaces/kbArchive';

@Injectable({
	providedIn: 'root',
})
export class SelfservicePageService {
	private getSelfserviceFirstQuestionUrl = environment.baseApiUrl + 'request/servicecatalog';
	private getSelfserviceNextQuestionUrl = environment.baseApiUrl + 'request/servicecatalog/{idNextQuestion}';
	private getSelfserviceByCategoryUrl = environment.baseApiUrl + 'request/servicecatalog/category/{idCategory}';
	private getTemplateUrl = environment.baseApiUrl + 'request/template/{idTemplate}';
	private getAvailableUsersUrl = environment.baseApiUrl + 'request/relatedEnduser';
	private postRequestUrl = environment.baseApiUrl + 'request';
	private postCustomfieldUrl = environment.baseApiUrl + 'request/{idRequest}/customField';
	private groupClassificationUrl =
		environment.baseApiUrl + 'request/classification/customer/{customerId}/servicetype/{serviceTypeId}/topic/{topicId}';
	private classificationUrl = environment.baseApiUrl + 'request/classification/customer/{customerId}/servicetype/{serviceTypeId}';
	private getRelatedKbArchivesUrl = environment.baseApiUrl + 'kb/related?{qryString}';

	private headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getSelfserviceFirstQuestion(id_customer: string): Observable<selfserviceQuestionInterface[]> {
		return this.http
			.get<JSON[]>(this.getSelfserviceFirstQuestionUrl, { headers: this.headers, params: { id_customer: id_customer } })
			.pipe(
				map((selfserviceQuestionRes: any) => {
					const selfserviceFirstQuestionArray: selfserviceQuestionInterface[] = [];

					selfserviceQuestionRes.forEach((selfserviceQuestion: any) => {
						const newSelfserviceQuestion: selfserviceQuestionInterface = {
							withDescription: selfserviceQuestion.withDescription,
							idQuestion: selfserviceQuestion.idQuestion,
							idCategory: selfserviceQuestion.idCategory,
							codQuestion: selfserviceQuestion.codQuestion,
							iconQuestion: this.formatIcons(selfserviceQuestion.iconQuestion),
							question: selfserviceQuestion.question,
							idResponse: selfserviceQuestion.idResponse,
							iconResponse: this.formatIcons(selfserviceQuestion.iconResponse),
							response: selfserviceQuestion.response,
							informative: selfserviceQuestion.informative,
							idNextQuestion: selfserviceQuestion.idNextQuestion,
							idResponseTemplate: selfserviceQuestion.idResponseTemplate,
							idResponseKb: selfserviceQuestion.idResponseKb,
							mobile: selfserviceQuestion.mobile,
							iconCategory: this.formatIcons(selfserviceQuestion.iconCategory),
							category: selfserviceQuestion.category,
							exturl: selfserviceQuestion.exturl,
							classificationRestricted: selfserviceQuestion.classificationRestricted,
						};

						selfserviceFirstQuestionArray.push(newSelfserviceQuestion);
					});

					return selfserviceFirstQuestionArray;
				})
			);
	}

	getNextQuestion(idNextQuestion: string): Observable<selfserviceQuestionInterface[]> {
		const getSelfserviceNextQuestionUrl = this.getSelfserviceNextQuestionUrl.replace('{idNextQuestion}', idNextQuestion);
		return this.http.get<JSON[]>(getSelfserviceNextQuestionUrl, { headers: this.headers }).pipe(
			map((selfserviceQuestionRes: any) => {
				const selfserviceFirstQuestionArray: selfserviceQuestionInterface[] = [];

				selfserviceQuestionRes.forEach((selfserviceQuestion: any) => {
					const newSelfserviceQuestion: selfserviceQuestionInterface = {
						withDescription: selfserviceQuestion.withDescription,
						idQuestion: selfserviceQuestion.idQuestion,
						idCategory: selfserviceQuestion.idCategory,
						codQuestion: selfserviceQuestion.codQuestion,
						iconQuestion: this.formatIcons(selfserviceQuestion.iconQuestion),
						question: selfserviceQuestion.question,
						idResponse: selfserviceQuestion.idResponse,
						iconResponse: this.formatIcons(selfserviceQuestion.iconResponse),
						response: selfserviceQuestion.response,
						informative: selfserviceQuestion.informative,
						idNextQuestion: selfserviceQuestion.idNextQuestion,
						idResponseTemplate: selfserviceQuestion.idResponseTemplate,
						idResponseKb: selfserviceQuestion.idResponseKb,
						mobile: selfserviceQuestion.mobile,
						iconCategory: this.formatIcons(selfserviceQuestion.iconCategory),
						category: selfserviceQuestion.category,
						exturl: selfserviceQuestion.exturl,
						classificationRestricted: selfserviceQuestion.classificationRestricted,
					};

					selfserviceFirstQuestionArray.push(newSelfserviceQuestion);
				});

				return selfserviceFirstQuestionArray;
			})
		);
	}

	getNextQuestionByCategory(id_category: string, id_customer: string): Observable<selfserviceQuestionInterface[]> {
		const getSelfserviceByCategoryUrl = this.getSelfserviceByCategoryUrl.replace('{idCategory}', id_category);
		return this.http.get<JSON[]>(getSelfserviceByCategoryUrl, { headers: this.headers, params: { id_customer: id_customer } }).pipe(
			map((selfserviceQuestionRes: any) => {
				const selfserviceFirstQuestionArray: selfserviceQuestionInterface[] = [];

				selfserviceQuestionRes.forEach((selfserviceQuestion: any) => {
					const newSelfserviceQuestion: selfserviceQuestionInterface = {
						withDescription: selfserviceQuestion.withDescription,
						idQuestion: selfserviceQuestion.idQuestion,
						idCategory: selfserviceQuestion.idCategory,
						codQuestion: selfserviceQuestion.codQuestion,
						iconQuestion: this.formatIcons(selfserviceQuestion.iconQuestion),
						question: selfserviceQuestion.question,
						idResponse: selfserviceQuestion.idResponse,
						iconResponse: this.formatIcons(selfserviceQuestion.iconResponse),
						response: selfserviceQuestion.response,
						informative: selfserviceQuestion.informative,
						idNextQuestion: selfserviceQuestion.idNextQuestion,
						idResponseTemplate: selfserviceQuestion.idResponseTemplate,
						idResponseKb: selfserviceQuestion.idResponseKb,
						mobile: selfserviceQuestion.mobile,
						iconCategory: this.formatIcons(selfserviceQuestion.iconCategory),
						category: selfserviceQuestion.category,
						exturl: selfserviceQuestion.exturl,
						classificationRestricted: selfserviceQuestion.classificationRestricted,
					};

					selfserviceFirstQuestionArray.push(newSelfserviceQuestion);
				});

				return selfserviceFirstQuestionArray;
			})
		);
	}

	getTemplate(idTemplate: string): Observable<templateReworkInterface> {
		const getTemplateUrl = this.getTemplateUrl.replace('{idTemplate}', idTemplate);
		return this.http.get<JSON[]>(getTemplateUrl, { headers: this.headers }).pipe(
			map((templateRes: any) => {
				templateRes = templateRes[0];
				const templateCustomFieldArray: templateCustomFieldsReworkInterface[] = [];
				if (templateRes.fields && templateRes.fields.length > 0) {
					templateRes.fields.forEach((customfieldRes: any) => {
						const newTemplateCustomField: templateCustomFieldsReworkInterface = {
							id: customfieldRes.id,
							field_name: customfieldRes.field_name,
							field_type: customfieldRes.field_type,
							required: customfieldRes.required === true || customfieldRes.required === '1' ? true : false,
							default_value: customfieldRes.default_value,
							hidden_field: customfieldRes.hidden_field,
							items: [],
							values: [],
						};

						customfieldRes.values.forEach((customfieldValueRes: any) => {
							const newItem = {
								name: customfieldValueRes.text_item,
								value: customfieldValueRes.value_item,
								default: customfieldValueRes.default_item,
								related_request_field: customfieldValueRes.related_request_field,
							};

							newTemplateCustomField.items.push(newItem);
						});

						templateCustomFieldArray.push(newTemplateCustomField);
					});
				}

				const templateInterface: templateReworkInterface = {
					id: templateRes.id,
					status: templateRes.status,
					summary: templateRes.summary,
					informative: templateRes.informative,
					description: templateRes.description,
					fields: templateCustomFieldArray,
				};

				return templateInterface;
			})
		);
	}

	getAvailableUsers(id_customer: string): Observable<enduserInterface[]> {
		return this.http
			.get<JSON[]>(this.getAvailableUsersUrl, { headers: this.headers, params: { id_enduser: '', id_customer: id_customer } })
			.pipe(
				map((endusersRes: any) => {
					const newEnduserArray: enduserInterface[] = [];

					endusersRes.forEach((enduser: any) => {
						const newEnduser: enduserInterface = {
							id: enduser.id,
							fullName: enduser.full_name,
							email: enduser.email,
						};

						newEnduserArray.push(newEnduser);
					});

					return newEnduserArray;
				})
			);
	}

	submitRequest(
		summary: string,
		description: string,
		idEnduser: string,
		idTemplate?: string,
		idSolutionArea?: string,
		idTopic?: string,
		idSeverity?: string
	): Observable<JSON> {
		const body: any = { summary: summary, description: description };
		if (idEnduser !== '-1') {
			body.idEnduser = idEnduser;
		}
		if (idTemplate && idTemplate !== '') {
			body.idTemplate = idTemplate;
		}
		if (idSolutionArea && idTopic && idSeverity && idSolutionArea !== '' && idTopic !== '' && idSeverity !== '') {
			body.idSolutionArea = idSolutionArea;
			body.idTopic = idTopic;
			body.idSeverity = idSeverity;
		}
		return this.http.post<JSON>(this.postRequestUrl, body, { headers: this.headers });
	}

	submitCustomfield(idRequest: string, customfieldBody: any): Observable<JSON> {
		const postCustomfieldUrl = this.postCustomfieldUrl.replace('{idRequest}', idRequest);
		return this.http.post<JSON>(postCustomfieldUrl, customfieldBody, { headers: this.headers });
	}

	formatIcons(iconText: string): string {
		if (iconText) {
			let newIconText = '';
			if (iconText.includes('-')) {
				newIconText += iconText.split('-')[0].replace('fas', 'fa').replace('far', 'fa');
				newIconText += iconText.split('-')[1].charAt(0).toUpperCase() + iconText.split('-')[1].slice(1);
			} else {
				newIconText = iconText;
			}

			return newIconText;
		}

		return null;
	}

	// getClassificationServiceType(): Observable<string[]> {
	//   let servicetypes = ["Problem","Incident","Change","Complaint","Service Request"];
	//   return of(servicetypes);
	// }

	getGroupsClassification(topicId: string, serviceTypeId: string, customerId: string): Observable<groupInterface[]> {
		let groupClassificationUrl = this.groupClassificationUrl.replace('{serviceTypeId}', serviceTypeId);
		groupClassificationUrl = groupClassificationUrl.replace('{customerId}', customerId);
		groupClassificationUrl = groupClassificationUrl.replace('{topicId}', topicId);
		return this.http.get<JSON>(groupClassificationUrl, { headers: this.headers }).pipe(
			map((groupJson: any) => {
				const newGroupArray: groupInterface[] = [];
				if (groupJson.solution_areas && groupJson.solution_areas.length > 0) {
					for (const group of groupJson.solution_areas) {
						const newGroup: groupInterface = {
							id: group.id,
							group_name: group.text,
							topic_id: topicId,
						};
						newGroupArray.push(newGroup);
					}
				}

				return newGroupArray;
			})
		);
	}

	getGeneralClassification(serviceTypeId: string, customerId: string): Observable<classificationInterface> {
		let classificationUrl = this.classificationUrl.replace('{serviceTypeId}', serviceTypeId);
		classificationUrl = classificationUrl.replace('{customerId}', customerId);
		return this.http.get<JSON>(classificationUrl, { headers: this.headers }).pipe(
			map((allCustomerClassification: any) => {
				const newClassification: classificationInterface = {
					serviceType: [],
					scope: [],
					category: [],
					topic: [],
					solutionArea: [],
				};

				const newScopeArray: scopeInterface[] = [];
				if (allCustomerClassification.scopes && allCustomerClassification.scopes.length > 0) {
					allCustomerClassification.scopes.forEach((scope: any) => {
						const newScope: scopeInterface = { id: scope.id, scope_name: scope.text };
						newScopeArray.push(newScope);
					});
				}
				newClassification.scope = newScopeArray;

				const newCategoryArray: categoryInterface[] = [];
				if (allCustomerClassification.categories && allCustomerClassification.categories.length > 0) {
					allCustomerClassification.categories.forEach((category: any) => {
						const newCategory: categoryInterface = { id: category.id, category_name: category.text, scope_id: category.scope };
						newCategoryArray.push(newCategory);
					});
				}
				newClassification.category = newCategoryArray;

				const newTopicArray: topicsInterface[] = [];
				if (allCustomerClassification.topics && allCustomerClassification.topics.length > 0) {
					allCustomerClassification.topics.forEach((topic: any) => {
						const newTopic: topicsInterface = {
							id: topic.id,
							topic_name: topic.text,
							category_id: topic.category,
							severity: topic.severity,
						};
						newTopicArray.push(newTopic);
					});
				}
				newClassification.topic = newTopicArray;

				return newClassification;
			})
		);
	}

	getRelatedKbArchives(summary: string): Observable<kbArchiveInterface[]> {
		const getRelatedKbArchivesUrl = this.getRelatedKbArchivesUrl.replace('{qryString}', `str=${summary}`);
		return this.http.get(getRelatedKbArchivesUrl, { headers: this.headers }).pipe(
			map((kbArray: any[]) => {
				const newKbArray: kbArchiveInterface[] = [];

				for (const kb of kbArray) {
					const newKb: kbArchiveInterface = {
						id: kb.id,
						summary: kb.summary,
						description: kb.description,
					};

					newKbArray.push(newKb);
				}

				return newKbArray;
			})
		);
	}
}
